/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Flow Do API
 * API таск-менеджера Flow Do. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateInputBody1,
  ErrorModel,
  Fields,
  ListOutputBody1,
  MemberSpacesBody,
  MembersOutputBody1,
  SpaceBody,
  TemplateInputBody
} from '../model';

import { apiFetch } from '../../http';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type memberSpacesListResponse200 = {
  data: MemberSpacesBody
  status: 200
}

export type memberSpacesListResponse403 = {
  data: ErrorModel
  status: 403
}

export type memberSpacesListResponse404 = {
  data: ErrorModel
  status: 404
}

export type memberSpacesListResponse422 = {
  data: ErrorModel
  status: 422
}

export type memberSpacesListResponse500 = {
  data: ErrorModel
  status: 500
}

export type memberSpacesListResponseSuccess = (memberSpacesListResponse200) & {
  headers: Headers;
};
export type memberSpacesListResponseError = (memberSpacesListResponse403 | memberSpacesListResponse404 | memberSpacesListResponse422 | memberSpacesListResponse500) & {
  headers: Headers;
};

export type memberSpacesListResponse = (memberSpacesListResponseSuccess | memberSpacesListResponseError)

export const getMemberSpacesListUrl = (workspace: string,
    userId: string,) => {




  return `/workspaces/${workspace}/members/${userId}/spaces`
}

/**
 * Все проекты пространства с отметкой, добавлен ли человек. Для страницы участников: доступ регулируется на уровне организации. Только владелец и администратор.
 * @summary Проекты участника
 */
export const memberSpacesList = async (workspace: string,
    userId: string, options?: Parameters<typeof apiFetch>[1]): Promise<memberSpacesListResponse> => {

  return apiFetch<memberSpacesListResponse>(getMemberSpacesListUrl(workspace,userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMemberSpacesListQueryKey = (workspace: string,
    userId: string,) => {
    return [
    `/workspaces/${workspace}/members/${userId}/spaces`
    ] as const;
    }


export const getMemberSpacesListQueryOptions = <TData = Awaited<ReturnType<typeof memberSpacesList>>, TError = ErrorModel>(workspace: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof memberSpacesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMemberSpacesListQueryKey(workspace,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof memberSpacesList>>> = ({ signal }) => memberSpacesList(workspace,userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workspace !== null && workspace !== undefined && userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof memberSpacesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MemberSpacesListQueryResult = NonNullable<Awaited<ReturnType<typeof memberSpacesList>>>
export type MemberSpacesListQueryError = ErrorModel


export function useMemberSpacesList<TData = Awaited<ReturnType<typeof memberSpacesList>>, TError = ErrorModel>(
 workspace: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof memberSpacesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof memberSpacesList>>,
          TError,
          Awaited<ReturnType<typeof memberSpacesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMemberSpacesList<TData = Awaited<ReturnType<typeof memberSpacesList>>, TError = ErrorModel>(
 workspace: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof memberSpacesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof memberSpacesList>>,
          TError,
          Awaited<ReturnType<typeof memberSpacesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMemberSpacesList<TData = Awaited<ReturnType<typeof memberSpacesList>>, TError = ErrorModel>(
 workspace: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof memberSpacesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Проекты участника
 */

export function useMemberSpacesList<TData = Awaited<ReturnType<typeof memberSpacesList>>, TError = ErrorModel>(
 workspace: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof memberSpacesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMemberSpacesListQueryOptions(workspace,userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type spacesListResponse200 = {
  data: ListOutputBody1
  status: 200
}

export type spacesListResponse404 = {
  data: ErrorModel
  status: 404
}

export type spacesListResponse422 = {
  data: ErrorModel
  status: 422
}

export type spacesListResponse500 = {
  data: ErrorModel
  status: 500
}

export type spacesListResponseSuccess = (spacesListResponse200) & {
  headers: Headers;
};
export type spacesListResponseError = (spacesListResponse404 | spacesListResponse422 | spacesListResponse500) & {
  headers: Headers;
};

export type spacesListResponse = (spacesListResponseSuccess | spacesListResponseError)

export const getSpacesListUrl = (workspace: string,) => {




  return `/workspaces/${workspace}/spaces`
}

/**
 * Те, куда текущего пользователя добавили. Владельцы и администраторы пространства видят все.
 * @summary Проекты пространства
 */
export const spacesList = async (workspace: string, options?: Parameters<typeof apiFetch>[1]): Promise<spacesListResponse> => {

  return apiFetch<spacesListResponse>(getSpacesListUrl(workspace),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSpacesListQueryKey = (workspace: string,) => {
    return [
    `/workspaces/${workspace}/spaces`
    ] as const;
    }


export const getSpacesListQueryOptions = <TData = Awaited<ReturnType<typeof spacesList>>, TError = ErrorModel>(workspace: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSpacesListQueryKey(workspace);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof spacesList>>> = ({ signal }) => spacesList(workspace, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workspace !== null && workspace !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof spacesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SpacesListQueryResult = NonNullable<Awaited<ReturnType<typeof spacesList>>>
export type SpacesListQueryError = ErrorModel


export function useSpacesList<TData = Awaited<ReturnType<typeof spacesList>>, TError = ErrorModel>(
 workspace: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof spacesList>>,
          TError,
          Awaited<ReturnType<typeof spacesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpacesList<TData = Awaited<ReturnType<typeof spacesList>>, TError = ErrorModel>(
 workspace: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof spacesList>>,
          TError,
          Awaited<ReturnType<typeof spacesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpacesList<TData = Awaited<ReturnType<typeof spacesList>>, TError = ErrorModel>(
 workspace: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Проекты пространства
 */

export function useSpacesList<TData = Awaited<ReturnType<typeof spacesList>>, TError = ErrorModel>(
 workspace: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSpacesListQueryOptions(workspace,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type spacesCreateResponse201 = {
  data: SpaceBody
  status: 201
}

export type spacesCreateResponse403 = {
  data: ErrorModel
  status: 403
}

export type spacesCreateResponse404 = {
  data: ErrorModel
  status: 404
}

export type spacesCreateResponse409 = {
  data: ErrorModel
  status: 409
}

export type spacesCreateResponse422 = {
  data: ErrorModel
  status: 422
}

export type spacesCreateResponse500 = {
  data: ErrorModel
  status: 500
}

export type spacesCreateResponseSuccess = (spacesCreateResponse201) & {
  headers: Headers;
};
export type spacesCreateResponseError = (spacesCreateResponse403 | spacesCreateResponse404 | spacesCreateResponse409 | spacesCreateResponse422 | spacesCreateResponse500) & {
  headers: Headers;
};

export type spacesCreateResponse = (spacesCreateResponseSuccess | spacesCreateResponseError)

export const getSpacesCreateUrl = (workspace: string,) => {




  return `/workspaces/${workspace}/spaces`
}

/**
 * Только владелец и администратор пространства.
 * @summary Создать проект
 */
export const spacesCreate = async (workspace: string,
    createInputBody1: NonReadonly<CreateInputBody1>, options?: Parameters<typeof apiFetch>[1]): Promise<spacesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<spacesCreateResponse>(getSpacesCreateUrl(workspace),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createInputBody1)
  }
);}





export const getSpacesCreateQueryKey = (workspace: string,
    createInputBody1?: NonReadonly<CreateInputBody1>,) => {
    return [
    'POST', `/workspaces/${workspace}/spaces`, createInputBody1
    ] as const;
    }


export const getSpacesCreateQueryOptions = <TData = Awaited<ReturnType<typeof spacesCreate>>, TError = ErrorModel>(workspace: string,
    createInputBody1: NonReadonly<CreateInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesCreate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSpacesCreateQueryKey(workspace,createInputBody1);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof spacesCreate>>> = ({ signal }) => spacesCreate(workspace,createInputBody1, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workspace !== null && workspace !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof spacesCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SpacesCreateQueryResult = NonNullable<Awaited<ReturnType<typeof spacesCreate>>>
export type SpacesCreateQueryError = ErrorModel


export function useSpacesCreate<TData = Awaited<ReturnType<typeof spacesCreate>>, TError = ErrorModel>(
 workspace: string,
    createInputBody1: NonReadonly<CreateInputBody1>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof spacesCreate>>,
          TError,
          Awaited<ReturnType<typeof spacesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpacesCreate<TData = Awaited<ReturnType<typeof spacesCreate>>, TError = ErrorModel>(
 workspace: string,
    createInputBody1: NonReadonly<CreateInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof spacesCreate>>,
          TError,
          Awaited<ReturnType<typeof spacesCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpacesCreate<TData = Awaited<ReturnType<typeof spacesCreate>>, TError = ErrorModel>(
 workspace: string,
    createInputBody1: NonReadonly<CreateInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesCreate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Создать проект
 */

export function useSpacesCreate<TData = Awaited<ReturnType<typeof spacesCreate>>, TError = ErrorModel>(
 workspace: string,
    createInputBody1: NonReadonly<CreateInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesCreate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSpacesCreateQueryOptions(workspace,createInputBody1,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type spacesDeleteResponse204 = {
  data: void
  status: 204
}

export type spacesDeleteResponse403 = {
  data: ErrorModel
  status: 403
}

export type spacesDeleteResponse404 = {
  data: ErrorModel
  status: 404
}

export type spacesDeleteResponse422 = {
  data: ErrorModel
  status: 422
}

export type spacesDeleteResponse500 = {
  data: ErrorModel
  status: 500
}

export type spacesDeleteResponseSuccess = (spacesDeleteResponse204) & {
  headers: Headers;
};
export type spacesDeleteResponseError = (spacesDeleteResponse403 | spacesDeleteResponse404 | spacesDeleteResponse422 | spacesDeleteResponse500) & {
  headers: Headers;
};

export type spacesDeleteResponse = (spacesDeleteResponseSuccess | spacesDeleteResponseError)

export const getSpacesDeleteUrl = (workspace: string,
    slug: string,) => {




  return `/workspaces/${workspace}/spaces/${slug}`
}

/**
 * В корзину: доски и задачи внутри перестают быть видны, но остаются в базе.
 * @summary Удалить проект
 */
export const spacesDelete = async (workspace: string,
    slug: string, options?: Parameters<typeof apiFetch>[1]): Promise<spacesDeleteResponse> => {

  return apiFetch<spacesDeleteResponse>(getSpacesDeleteUrl(workspace,slug),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getSpacesDeleteQueryKey = (workspace: string,
    slug: string,) => {
    return [
    'DELETE', `/workspaces/${workspace}/spaces/${slug}`
    ] as const;
    }


export const getSpacesDeleteQueryOptions = <TData = Awaited<ReturnType<typeof spacesDelete>>, TError = ErrorModel>(workspace: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesDelete>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSpacesDeleteQueryKey(workspace,slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof spacesDelete>>> = ({ signal }) => spacesDelete(workspace,slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workspace !== null && workspace !== undefined && slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof spacesDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SpacesDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof spacesDelete>>>
export type SpacesDeleteQueryError = ErrorModel


export function useSpacesDelete<TData = Awaited<ReturnType<typeof spacesDelete>>, TError = ErrorModel>(
 workspace: string,
    slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof spacesDelete>>,
          TError,
          Awaited<ReturnType<typeof spacesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpacesDelete<TData = Awaited<ReturnType<typeof spacesDelete>>, TError = ErrorModel>(
 workspace: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof spacesDelete>>,
          TError,
          Awaited<ReturnType<typeof spacesDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpacesDelete<TData = Awaited<ReturnType<typeof spacesDelete>>, TError = ErrorModel>(
 workspace: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesDelete>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Удалить проект
 */

export function useSpacesDelete<TData = Awaited<ReturnType<typeof spacesDelete>>, TError = ErrorModel>(
 workspace: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesDelete>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSpacesDeleteQueryOptions(workspace,slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type spacesGetResponse200 = {
  data: SpaceBody
  status: 200
}

export type spacesGetResponse404 = {
  data: ErrorModel
  status: 404
}

export type spacesGetResponse422 = {
  data: ErrorModel
  status: 422
}

export type spacesGetResponse500 = {
  data: ErrorModel
  status: 500
}

export type spacesGetResponseSuccess = (spacesGetResponse200) & {
  headers: Headers;
};
export type spacesGetResponseError = (spacesGetResponse404 | spacesGetResponse422 | spacesGetResponse500) & {
  headers: Headers;
};

export type spacesGetResponse = (spacesGetResponseSuccess | spacesGetResponseError)

export const getSpacesGetUrl = (workspace: string,
    slug: string,) => {




  return `/workspaces/${workspace}/spaces/${slug}`
}

/**
 * @summary Проект
 */
export const spacesGet = async (workspace: string,
    slug: string, options?: Parameters<typeof apiFetch>[1]): Promise<spacesGetResponse> => {

  return apiFetch<spacesGetResponse>(getSpacesGetUrl(workspace,slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSpacesGetQueryKey = (workspace: string,
    slug: string,) => {
    return [
    `/workspaces/${workspace}/spaces/${slug}`
    ] as const;
    }


export const getSpacesGetQueryOptions = <TData = Awaited<ReturnType<typeof spacesGet>>, TError = ErrorModel>(workspace: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesGet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSpacesGetQueryKey(workspace,slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof spacesGet>>> = ({ signal }) => spacesGet(workspace,slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workspace !== null && workspace !== undefined && slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof spacesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SpacesGetQueryResult = NonNullable<Awaited<ReturnType<typeof spacesGet>>>
export type SpacesGetQueryError = ErrorModel


export function useSpacesGet<TData = Awaited<ReturnType<typeof spacesGet>>, TError = ErrorModel>(
 workspace: string,
    slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof spacesGet>>,
          TError,
          Awaited<ReturnType<typeof spacesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpacesGet<TData = Awaited<ReturnType<typeof spacesGet>>, TError = ErrorModel>(
 workspace: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof spacesGet>>,
          TError,
          Awaited<ReturnType<typeof spacesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpacesGet<TData = Awaited<ReturnType<typeof spacesGet>>, TError = ErrorModel>(
 workspace: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesGet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Проект
 */

export function useSpacesGet<TData = Awaited<ReturnType<typeof spacesGet>>, TError = ErrorModel>(
 workspace: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesGet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSpacesGetQueryOptions(workspace,slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type spacesUpdateResponse200 = {
  data: SpaceBody
  status: 200
}

export type spacesUpdateResponse403 = {
  data: ErrorModel
  status: 403
}

export type spacesUpdateResponse404 = {
  data: ErrorModel
  status: 404
}

export type spacesUpdateResponse422 = {
  data: ErrorModel
  status: 422
}

export type spacesUpdateResponse500 = {
  data: ErrorModel
  status: 500
}

export type spacesUpdateResponseSuccess = (spacesUpdateResponse200) & {
  headers: Headers;
};
export type spacesUpdateResponseError = (spacesUpdateResponse403 | spacesUpdateResponse404 | spacesUpdateResponse422 | spacesUpdateResponse500) & {
  headers: Headers;
};

export type spacesUpdateResponse = (spacesUpdateResponseSuccess | spacesUpdateResponseError)

export const getSpacesUpdateUrl = (workspace: string,
    slug: string,) => {




  return `/workspaces/${workspace}/spaces/${slug}`
}

/**
 * @summary Изменить проект
 */
export const spacesUpdate = async (workspace: string,
    slug: string,
    fields: NonReadonly<Fields>, options?: Parameters<typeof apiFetch>[1]): Promise<spacesUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<spacesUpdateResponse>(getSpacesUpdateUrl(workspace,slug),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(fields)
  }
);}





export const getSpacesUpdateQueryKey = (workspace: string,
    slug: string,
    fields?: NonReadonly<Fields>,) => {
    return [
    'PATCH', `/workspaces/${workspace}/spaces/${slug}`, fields
    ] as const;
    }


export const getSpacesUpdateQueryOptions = <TData = Awaited<ReturnType<typeof spacesUpdate>>, TError = ErrorModel>(workspace: string,
    slug: string,
    fields: NonReadonly<Fields>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesUpdate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSpacesUpdateQueryKey(workspace,slug,fields);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof spacesUpdate>>> = ({ signal }) => spacesUpdate(workspace,slug,fields, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workspace !== null && workspace !== undefined && slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof spacesUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SpacesUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof spacesUpdate>>>
export type SpacesUpdateQueryError = ErrorModel


export function useSpacesUpdate<TData = Awaited<ReturnType<typeof spacesUpdate>>, TError = ErrorModel>(
 workspace: string,
    slug: string,
    fields: NonReadonly<Fields>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof spacesUpdate>>,
          TError,
          Awaited<ReturnType<typeof spacesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpacesUpdate<TData = Awaited<ReturnType<typeof spacesUpdate>>, TError = ErrorModel>(
 workspace: string,
    slug: string,
    fields: NonReadonly<Fields>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof spacesUpdate>>,
          TError,
          Awaited<ReturnType<typeof spacesUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpacesUpdate<TData = Awaited<ReturnType<typeof spacesUpdate>>, TError = ErrorModel>(
 workspace: string,
    slug: string,
    fields: NonReadonly<Fields>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesUpdate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Изменить проект
 */

export function useSpacesUpdate<TData = Awaited<ReturnType<typeof spacesUpdate>>, TError = ErrorModel>(
 workspace: string,
    slug: string,
    fields: NonReadonly<Fields>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesUpdate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSpacesUpdateQueryOptions(workspace,slug,fields,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type spaceMembersListResponse200 = {
  data: MembersOutputBody1
  status: 200
}

export type spaceMembersListResponse404 = {
  data: ErrorModel
  status: 404
}

export type spaceMembersListResponse422 = {
  data: ErrorModel
  status: 422
}

export type spaceMembersListResponse500 = {
  data: ErrorModel
  status: 500
}

export type spaceMembersListResponseSuccess = (spaceMembersListResponse200) & {
  headers: Headers;
};
export type spaceMembersListResponseError = (spaceMembersListResponse404 | spaceMembersListResponse422 | spaceMembersListResponse500) & {
  headers: Headers;
};

export type spaceMembersListResponse = (spaceMembersListResponseSuccess | spaceMembersListResponseError)

export const getSpaceMembersListUrl = (workspace: string,
    slug: string,) => {




  return `/workspaces/${workspace}/spaces/${slug}/members`
}

/**
 * Владельцы и администраторы пространства в список не входят — они видят все проекты и так.
 * @summary Кто добавлен в проект
 */
export const spaceMembersList = async (workspace: string,
    slug: string, options?: Parameters<typeof apiFetch>[1]): Promise<spaceMembersListResponse> => {

  return apiFetch<spaceMembersListResponse>(getSpaceMembersListUrl(workspace,slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSpaceMembersListQueryKey = (workspace: string,
    slug: string,) => {
    return [
    `/workspaces/${workspace}/spaces/${slug}/members`
    ] as const;
    }


export const getSpaceMembersListQueryOptions = <TData = Awaited<ReturnType<typeof spaceMembersList>>, TError = ErrorModel>(workspace: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spaceMembersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSpaceMembersListQueryKey(workspace,slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof spaceMembersList>>> = ({ signal }) => spaceMembersList(workspace,slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workspace !== null && workspace !== undefined && slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof spaceMembersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SpaceMembersListQueryResult = NonNullable<Awaited<ReturnType<typeof spaceMembersList>>>
export type SpaceMembersListQueryError = ErrorModel


export function useSpaceMembersList<TData = Awaited<ReturnType<typeof spaceMembersList>>, TError = ErrorModel>(
 workspace: string,
    slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof spaceMembersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof spaceMembersList>>,
          TError,
          Awaited<ReturnType<typeof spaceMembersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpaceMembersList<TData = Awaited<ReturnType<typeof spaceMembersList>>, TError = ErrorModel>(
 workspace: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spaceMembersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof spaceMembersList>>,
          TError,
          Awaited<ReturnType<typeof spaceMembersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpaceMembersList<TData = Awaited<ReturnType<typeof spaceMembersList>>, TError = ErrorModel>(
 workspace: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spaceMembersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Кто добавлен в проект
 */

export function useSpaceMembersList<TData = Awaited<ReturnType<typeof spaceMembersList>>, TError = ErrorModel>(
 workspace: string,
    slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spaceMembersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSpaceMembersListQueryOptions(workspace,slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type spaceMemberRemoveResponse204 = {
  data: void
  status: 204
}

export type spaceMemberRemoveResponse403 = {
  data: ErrorModel
  status: 403
}

export type spaceMemberRemoveResponse404 = {
  data: ErrorModel
  status: 404
}

export type spaceMemberRemoveResponse422 = {
  data: ErrorModel
  status: 422
}

export type spaceMemberRemoveResponse500 = {
  data: ErrorModel
  status: 500
}

export type spaceMemberRemoveResponseSuccess = (spaceMemberRemoveResponse204) & {
  headers: Headers;
};
export type spaceMemberRemoveResponseError = (spaceMemberRemoveResponse403 | spaceMemberRemoveResponse404 | spaceMemberRemoveResponse422 | spaceMemberRemoveResponse500) & {
  headers: Headers;
};

export type spaceMemberRemoveResponse = (spaceMemberRemoveResponseSuccess | spaceMemberRemoveResponseError)

export const getSpaceMemberRemoveUrl = (workspace: string,
    slug: string,
    userId: string,) => {




  return `/workspaces/${workspace}/spaces/${slug}/members/${userId}`
}

/**
 * @summary Закрыть доступ к проекту
 */
export const spaceMemberRemove = async (workspace: string,
    slug: string,
    userId: string, options?: Parameters<typeof apiFetch>[1]): Promise<spaceMemberRemoveResponse> => {

  return apiFetch<spaceMemberRemoveResponse>(getSpaceMemberRemoveUrl(workspace,slug,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getSpaceMemberRemoveQueryKey = (workspace: string,
    slug: string,
    userId: string,) => {
    return [
    'DELETE', `/workspaces/${workspace}/spaces/${slug}/members/${userId}`
    ] as const;
    }


export const getSpaceMemberRemoveQueryOptions = <TData = Awaited<ReturnType<typeof spaceMemberRemove>>, TError = ErrorModel>(workspace: string,
    slug: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spaceMemberRemove>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSpaceMemberRemoveQueryKey(workspace,slug,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof spaceMemberRemove>>> = ({ signal }) => spaceMemberRemove(workspace,slug,userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workspace !== null && workspace !== undefined && slug !== null && slug !== undefined && userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof spaceMemberRemove>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SpaceMemberRemoveQueryResult = NonNullable<Awaited<ReturnType<typeof spaceMemberRemove>>>
export type SpaceMemberRemoveQueryError = ErrorModel


export function useSpaceMemberRemove<TData = Awaited<ReturnType<typeof spaceMemberRemove>>, TError = ErrorModel>(
 workspace: string,
    slug: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof spaceMemberRemove>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof spaceMemberRemove>>,
          TError,
          Awaited<ReturnType<typeof spaceMemberRemove>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpaceMemberRemove<TData = Awaited<ReturnType<typeof spaceMemberRemove>>, TError = ErrorModel>(
 workspace: string,
    slug: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spaceMemberRemove>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof spaceMemberRemove>>,
          TError,
          Awaited<ReturnType<typeof spaceMemberRemove>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpaceMemberRemove<TData = Awaited<ReturnType<typeof spaceMemberRemove>>, TError = ErrorModel>(
 workspace: string,
    slug: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spaceMemberRemove>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Закрыть доступ к проекту
 */

export function useSpaceMemberRemove<TData = Awaited<ReturnType<typeof spaceMemberRemove>>, TError = ErrorModel>(
 workspace: string,
    slug: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spaceMemberRemove>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSpaceMemberRemoveQueryOptions(workspace,slug,userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type spaceMemberAddResponse204 = {
  data: void
  status: 204
}

export type spaceMemberAddResponse403 = {
  data: ErrorModel
  status: 403
}

export type spaceMemberAddResponse404 = {
  data: ErrorModel
  status: 404
}

export type spaceMemberAddResponse422 = {
  data: ErrorModel
  status: 422
}

export type spaceMemberAddResponse500 = {
  data: ErrorModel
  status: 500
}

export type spaceMemberAddResponseSuccess = (spaceMemberAddResponse204) & {
  headers: Headers;
};
export type spaceMemberAddResponseError = (spaceMemberAddResponse403 | spaceMemberAddResponse404 | spaceMemberAddResponse422 | spaceMemberAddResponse500) & {
  headers: Headers;
};

export type spaceMemberAddResponse = (spaceMemberAddResponseSuccess | spaceMemberAddResponseError)

export const getSpaceMemberAddUrl = (workspace: string,
    slug: string,
    userId: string,) => {




  return `/workspaces/${workspace}/spaces/${slug}/members/${userId}`
}

/**
 * Человек должен быть участником пространства. Права внутри проекта определяет его роль в пространстве.
 * @summary Открыть доступ к проекту
 */
export const spaceMemberAdd = async (workspace: string,
    slug: string,
    userId: string, options?: Parameters<typeof apiFetch>[1]): Promise<spaceMemberAddResponse> => {

  return apiFetch<spaceMemberAddResponse>(getSpaceMemberAddUrl(workspace,slug,userId),
  {
    ...options,
    method: 'PUT'


  }
);}





export const getSpaceMemberAddQueryKey = (workspace: string,
    slug: string,
    userId: string,) => {
    return [
    'PUT', `/workspaces/${workspace}/spaces/${slug}/members/${userId}`
    ] as const;
    }


export const getSpaceMemberAddQueryOptions = <TData = Awaited<ReturnType<typeof spaceMemberAdd>>, TError = ErrorModel>(workspace: string,
    slug: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spaceMemberAdd>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSpaceMemberAddQueryKey(workspace,slug,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof spaceMemberAdd>>> = ({ signal }) => spaceMemberAdd(workspace,slug,userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workspace !== null && workspace !== undefined && slug !== null && slug !== undefined && userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof spaceMemberAdd>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SpaceMemberAddQueryResult = NonNullable<Awaited<ReturnType<typeof spaceMemberAdd>>>
export type SpaceMemberAddQueryError = ErrorModel


export function useSpaceMemberAdd<TData = Awaited<ReturnType<typeof spaceMemberAdd>>, TError = ErrorModel>(
 workspace: string,
    slug: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof spaceMemberAdd>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof spaceMemberAdd>>,
          TError,
          Awaited<ReturnType<typeof spaceMemberAdd>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpaceMemberAdd<TData = Awaited<ReturnType<typeof spaceMemberAdd>>, TError = ErrorModel>(
 workspace: string,
    slug: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spaceMemberAdd>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof spaceMemberAdd>>,
          TError,
          Awaited<ReturnType<typeof spaceMemberAdd>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpaceMemberAdd<TData = Awaited<ReturnType<typeof spaceMemberAdd>>, TError = ErrorModel>(
 workspace: string,
    slug: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spaceMemberAdd>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Открыть доступ к проекту
 */

export function useSpaceMemberAdd<TData = Awaited<ReturnType<typeof spaceMemberAdd>>, TError = ErrorModel>(
 workspace: string,
    slug: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spaceMemberAdd>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSpaceMemberAddQueryOptions(workspace,slug,userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type spacesSetTemplateResponse200 = {
  data: SpaceBody
  status: 200
}

export type spacesSetTemplateResponse403 = {
  data: ErrorModel
  status: 403
}

export type spacesSetTemplateResponse404 = {
  data: ErrorModel
  status: 404
}

export type spacesSetTemplateResponse422 = {
  data: ErrorModel
  status: 422
}

export type spacesSetTemplateResponse500 = {
  data: ErrorModel
  status: 500
}

export type spacesSetTemplateResponseSuccess = (spacesSetTemplateResponse200) & {
  headers: Headers;
};
export type spacesSetTemplateResponseError = (spacesSetTemplateResponse403 | spacesSetTemplateResponse404 | spacesSetTemplateResponse422 | spacesSetTemplateResponse500) & {
  headers: Headers;
};

export type spacesSetTemplateResponse = (spacesSetTemplateResponseSuccess | spacesSetTemplateResponseError)

export const getSpacesSetTemplateUrl = (workspace: string,
    slug: string,) => {




  return `/workspaces/${workspace}/spaces/${slug}/template`
}

/**
 * Шаблон — обычный проект, заполненный как образец: свойства, теги, доски со статусами. Задачи при создании из шаблона не копируются.
 * @summary Пометить проект шаблоном
 */
export const spacesSetTemplate = async (workspace: string,
    slug: string,
    templateInputBody: NonReadonly<TemplateInputBody>, options?: Parameters<typeof apiFetch>[1]): Promise<spacesSetTemplateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<spacesSetTemplateResponse>(getSpacesSetTemplateUrl(workspace,slug),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(templateInputBody)
  }
);}





export const getSpacesSetTemplateQueryKey = (workspace: string,
    slug: string,
    templateInputBody?: NonReadonly<TemplateInputBody>,) => {
    return [
    'POST', `/workspaces/${workspace}/spaces/${slug}/template`, templateInputBody
    ] as const;
    }


export const getSpacesSetTemplateQueryOptions = <TData = Awaited<ReturnType<typeof spacesSetTemplate>>, TError = ErrorModel>(workspace: string,
    slug: string,
    templateInputBody: NonReadonly<TemplateInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesSetTemplate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSpacesSetTemplateQueryKey(workspace,slug,templateInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof spacesSetTemplate>>> = ({ signal }) => spacesSetTemplate(workspace,slug,templateInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workspace !== null && workspace !== undefined && slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof spacesSetTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SpacesSetTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof spacesSetTemplate>>>
export type SpacesSetTemplateQueryError = ErrorModel


export function useSpacesSetTemplate<TData = Awaited<ReturnType<typeof spacesSetTemplate>>, TError = ErrorModel>(
 workspace: string,
    slug: string,
    templateInputBody: NonReadonly<TemplateInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesSetTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof spacesSetTemplate>>,
          TError,
          Awaited<ReturnType<typeof spacesSetTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpacesSetTemplate<TData = Awaited<ReturnType<typeof spacesSetTemplate>>, TError = ErrorModel>(
 workspace: string,
    slug: string,
    templateInputBody: NonReadonly<TemplateInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesSetTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof spacesSetTemplate>>,
          TError,
          Awaited<ReturnType<typeof spacesSetTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSpacesSetTemplate<TData = Awaited<ReturnType<typeof spacesSetTemplate>>, TError = ErrorModel>(
 workspace: string,
    slug: string,
    templateInputBody: NonReadonly<TemplateInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesSetTemplate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Пометить проект шаблоном
 */

export function useSpacesSetTemplate<TData = Awaited<ReturnType<typeof spacesSetTemplate>>, TError = ErrorModel>(
 workspace: string,
    slug: string,
    templateInputBody: NonReadonly<TemplateInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof spacesSetTemplate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSpacesSetTemplateQueryOptions(workspace,slug,templateInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






